<template>
  <div class="examitem" v-for="item in examItem" :key="item._id">
    <ul>
      <li>
        <RouterLink
          target="_blank"
          :to="`/examline/linedetail?lineID=${item.lineID}&clID=${item.clID}`"
          >{{ item.lineName }}
        </RouterLink>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    examItem: {
      type: Array,
      default: () => [],
    },
  },
  setup() {
    return {};
  },
};
</script>

<style lang="less" scoped>
.examitem {
  background: #fff;
  ul {
    & :hover {
      color: @shColor;
    }
    li {
      height: 50px;
      font-size: 15px;
      line-height: 50px;
      padding-left: 50px;
      border-bottom: 1px solid #dedede;
      width: 830px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      //background: #dedede;
    }
  }
}
</style>
